// Per-theme scene setup, kept out of pendant-scene.js (a collision hotspot).
// ONE equirect HDR per theme is used both as scene.background and (PMREM-filtered) as the
// reflection environment, so the backdrop and the metal reflections agree.

/** @type {Record<import('../types/pendant.js').ThemeMode, import('../types/pendant.js').SceneLook>} */
export const LOOKS = {
  light: {
    hdr: '/env/brown_photostudio_02_1k.hdr',
    exposure: 0.85,
    envIntensity: 1.5,
    backgroundIntensity: 1.1,
    blur: 0.08,
    rotation: Math.PI,
    desaturate: 0,
    ambient: 0.22,
    key: 12000,
    rim: 10000,
    fill: 5000,
  },
  dark: {
    hdr: '/env/warm_restaurant_night_1k.hdr',
    exposure: 1.0,
    envIntensity: 1.2,
    backgroundIntensity: 0.5,
    blur: 0.14,
    rotation: 0,
    desaturate: 0.75,
    ambient: 0.05,
    key: 8000,
    rim: 12000,
    fill: 3000,
  },
}
